import React from "react";
import "./Navbars.css";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const Navbars = () => {
  return (
    <Navbar
      bg="secondary "
      expand="lg"
      className="navbar-light bg-secondary sticky-top"
    >
      <Container>
        <Navbar.Brand className="text-warning fw-bold fs-3" to="/">
          Quiz Game
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavLink className="nav-link text-white" to="/">
              Home
            </NavLink>
            <NavLink className="nav-link text-white" to="/statistics">
              Statistic
            </NavLink>
            <NavLink className="nav-link text-white" to="/blogs">
              Blogs
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navbars;
